<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        class="buttons"
        v-if="
          $userCheckAccess({
            abilities: 'edit_business_segments',
          })
        "
      >
        <BusinessSegmentModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-business_segment']['dialog-delete'][
              'udalit-segment'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import BusinessSegmentModal from 'components/setting/businessSegment/BusinessSegmentModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'BusinessSegmentTableItem',
  components: { BusinessSegmentModal, DeleteModal },
  props: ['item'],
}
</script>
